import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { Order } from './../../common/models/order';
import { OrderItem } from './../../common/models/orderitem';
import { Product } from './../../common/models/product';
import { mockupProducts } from './../../common/config/mokup-data';
import { PaymentHistoryLog } from '../../common/models/PaymentHistoryLog';

import { LaddaModule } from 'angular2-ladda';
import { SessionManager } from '../../common/helpers/session-manager';
import { EmailService } from './../../common/services/email.service';
import { ProductService } from '../../shopping-cart/services/product.service';
import { PaymentService } from '../../payment-gateway/services/payment.service';
import { InvoiceService } from '../../payment-gateway/services/invoice.service';
import { AppLoggingService } from '../../common/services/AppLogging.service';
import { paymentMethod, transactionLogDescription } from '../../common/helpers/string-helper';

// Operators
import 'rxjs/add/operator/map';
import * as _ from 'lodash';


@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.css']
})
export class OrderConfirmationComponent implements OnInit {

  promotionProducts: Product[] = [];
  mockupProducts: Product[] = [];
  invoiceMe = false;
  progress: boolean | number = false;
  promoCode: string;
  customerDetails: any;
  order = new Order();
  paymentHistoryLog = new PaymentHistoryLog();
  sessionId: string;
  orderMessageLable: string;

  constructor(private router: Router,
    private emailService: EmailService,
    private sessionManager: SessionManager,
    private productService: ProductService,
    private paymentService: PaymentService,
    private invoiceService: InvoiceService,
    private log: AppLoggingService) { }


  ngOnInit() {

    this.customerDetails = this.sessionManager.getCurrentUser();
    this.order = this.sessionManager.getShoppingCartData();
    this.promoCode = this.sessionManager.getPromoCode();
    this.sessionId = localStorage.getItem('sessionID');
    this.orderMessageLable = localStorage.getItem('orderLabel');
  }


  sendInvoice() {
   
    this.progress = 0;
    // order confirmation start using manual process
    this.log.AddPaymentTransactionLog(this.customerDetails.id, null, this.order.orderId, this.order.orderTotal, this.order.orderTotal,
      transactionLogDescription.orderConfirmManualDesc, paymentMethod.invoice, 3, true, this.customerDetails.email, this.promoCode).subscribe((response: Response) => { });

    // set payment history details
    this.paymentHistoryLog.customerId = this.customerDetails.id;
    this.paymentHistoryLog.orderId = this.order.orderId;
    this.paymentHistoryLog.amount = this.order.orderTotal;
    this.paymentHistoryLog.total = this.order.orderTotal;
    this.paymentHistoryLog.paymentMethod = paymentMethod.invoice;
    this.paymentHistoryLog.statusId = 4;
    this.paymentHistoryLog.isActive = true;
    this.paymentHistoryLog.email = this.customerDetails.email;
    this.paymentHistoryLog.promoCode = this.promoCode;

    this.invoiceService.createInvoice(this.customerDetails.id, this.order, 0, this.paymentHistoryLog, this.sessionId, true)
      .subscribe(createInvoiceSuccess => {

        // Add order completed using manual process log
        this.log.AddPaymentTransactionLog(this.customerDetails.id, null, this.order.orderId, this.order.orderTotal,
          this.order.orderTotal, transactionLogDescription.orderCompletedManualDesc, paymentMethod.invoice, 44,
          true, this.customerDetails.email, this.promoCode).subscribe((response: Response) => {

            // Update payment transaction log with invoice number
            this.log.UpdatePaymentTransactionLog(this.customerDetails.id, null, this.order.orderId, null, null, null, null, 44,
              true, null, null, createInvoiceSuccess.invoiceNumber)
              .subscribe((response: Response) => { });
          });

        this.router.navigate(['/thankyou']);

      }, createInvoiceError => {

        // Add invoice creation failed using manual process log
        this.log.AddPaymentTransactionLog(this.customerDetails.id, null, this.order.orderId, this.order.orderTotal,
          this.order.orderTotal, transactionLogDescription.manualInvoiceCreationFailedDesc, paymentMethod.invoice,
          16, true, this.customerDetails.email, this.promoCode).subscribe((response: Response) => { });

        this.router.navigate(['/thankyou']);

      });
  }


  changePaytype(paytype: boolean) {
    this.invoiceMe = paytype;
  }


  purchaseInfo() {

    // order confirmation start - credit card
    this.log.AddPaymentTransactionLog(this.customerDetails.id, null, this.order.orderId, this.order.orderTotal,
      this.order.orderTotal, transactionLogDescription.orderConfirmCreditCardDesc, paymentMethod.creditCard, 3,
      true, this.customerDetails.email,
      this.promoCode).subscribe((response: Response) => { });

    this.router.navigate(['payment']);
  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/shopping-cart/order-confirmation/order-confirmation.component.ts